import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CountItem from './CountItem';
import { formatCount } from '../utils/formatCount';

class Counts extends React.Component {
	constructor(props) {
		super(props);
		this.trackGa = this.trackGa.bind(this);
	}

	trackGa(trackingObj) {
		const isBrowser = typeof window !== 'undefined';
		if (isBrowser) {
			const DDC = window.DDC || {};
			const defaultTrackingObj = {
				event: 'widgetUserEvent',
				widgetName: 'ws-inv-count-display',
				widgetId: this.props.windowId,
				widgetState: 'default',
				element: '',
				action: 'clicked',
				result: '',
				elementCta: ''
			};

			if (DDC.pushToGtmDataLayer) {
				DDC.pushToGtmDataLayer({
					...defaultTrackingObj,
					...trackingObj
				});
			}
		}
	}

	render() {
		const {
			prefs: {
				showCounts,
				makeLabel,
				dealershipLabel,
				newVehicleLabel,
				certifiedVehicleLabel,
				preownedVehicleLabel,
				makeLink,
				dealershipLink,
				newVehicleLink,
				certifiedVehicleLink,
				preownedVehicleLink,
				roundVehiclesTo,
				animate,
				makeCount,
				dealershipCount,
				textColor,
				countTextSize,
				labelTextSize
			},
			labels,
			sitemap,
			counts,
			locale
		} = this.props;

		/**
		 * Gets the label, hyperlink, and formatted count for each countItem.
		 * If a custom link via preferences cannot be found, they will default
		 * to the default params.
		 *
		 * @param label
		 * @param link
		 * @param count
		 * @param floorTo
		 */
		const getCountData = (label, link, count, floorTo) => {
			const countData = {};

			countData.label = labels.get(label);

			countData.link = sitemap.get(link);

			const formatObj = formatCount(parseInt(count, 10), floorTo, locale);
			countData.count = formatObj.number;

			countData.rounded = formatObj.rounded;
			return countData;
		};

		const displayedCounts = showCounts.split(',');

		// Create array of CountItem components with appropriate values based on key
		const countArray = displayedCounts.reduce((acc, key) => {
			let countData = {};
			switch (key) {
				case 'USED_VEHICLES':
					countData = getCountData(
						preownedVehicleLabel,
						preownedVehicleLink,
						counts[key],
						roundVehiclesTo
					);
					break;
				case 'NEW_VEHICLES':
					countData = getCountData(
						newVehicleLabel,
						newVehicleLink,
						counts[key],
						roundVehiclesTo
					);
					break;
				case 'CERTIFIED_VEHICLES':
					countData = getCountData(
						certifiedVehicleLabel,
						certifiedVehicleLink,
						counts[key],
						roundVehiclesTo
					);
					break;
				case 'MAKES':
					countData = getCountData(makeLabel, makeLink, makeCount, 1);
					break;
				case 'DEALERSHIPS':
				default:
					countData = getCountData(
						dealershipLabel,
						dealershipLink,
						dealershipCount,
						1
					);
			}
			acc.push(
				<CountItem
					key={key}
					className={key}
					label={countData.label}
					count={countData.count}
					link={countData.link}
					textColor={textColor}
					countTextSize={countTextSize}
					labelTextSize={labelTextSize}
					animate={JSON.parse(animate)}
					rounded={countData.rounded}
					trackGa={this.trackGa}
					name={key}
				/>
			);
			return acc;
		}, []);

		return (
			<div className="d-flex flex-wrap justify-content-around text-center pt-3 pb-4 m-3">
				{countArray}
			</div>
		);
	}
}

Counts.propTypes = {
	prefs: PropTypes.shape({
		showCounts: PropTypes.string.isRequired,
		makeLabel: PropTypes.string.isRequired,
		dealershipLabel: PropTypes.string.isRequired,
		newVehicleLabel: PropTypes.string.isRequired,
		certifiedVehicleLabel: PropTypes.string.isRequired,
		preownedVehicleLabel: PropTypes.string.isRequired,
		makeLink: PropTypes.string.isRequired,
		dealershipLink: PropTypes.string.isRequired,
		newVehicleLink: PropTypes.string.isRequired,
		certifiedVehicleLink: PropTypes.string.isRequired,
		preownedVehicleLink: PropTypes.string.isRequired,
		roundVehiclesTo: PropTypes.string.isRequired,
		animate: PropTypes.string.isRequired,
		makeCount: PropTypes.string.isRequired,
		dealershipCount: PropTypes.string.isRequired,
		textColor: PropTypes.string.isRequired,
		countTextSize: PropTypes.string.isRequired,
		labelTextSize: PropTypes.string.isRequired
	}).isRequired,
	labels: PropTypes.shape({
		get: PropTypes.func.isRequired
	}).isRequired,
	sitemap: PropTypes.shape({
		get: PropTypes.func.isRequired
	}).isRequired,
	counts: PropTypes.shape({}).isRequired,
	locale: PropTypes.string.isRequired,
	windowId: PropTypes.string.isRequired
};

const mapStateToProps = state => {
	return {
		counts: state.counts,
		locale: state.requestData.locale,
		windowId: state.requestData.windowId
	};
};

const CountsComponent = connect(mapStateToProps)(Counts);

export default CountsComponent;



// WEBPACK FOOTER //
// ./src/components/Counts.jsx